import React, { useState } from "react";
import { Link } from "react-router";

import Logo from "../assets/Logo-OpenMind_black.svg";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="flex justify-between items-center z-20 px-14 py-7 bg-white h-[91px] max-md:p-8 max-sm:p-4 relative">
      <Link to="/">
        <img src={Logo} alt="OpenMind Logo" className="h-8 w-auto" />
      </Link>

      {/* Desktop Navigation */}
      <nav className="flex gap-16 ml-auto pr-12 max-lg:gap-8 max-lg:hidden">
        <Link
          to={{ pathname: "/about" }}
          className="text-lg tracking-tight text-black hover:text-gray-700"
        >
          About
        </Link>
        <Link
          to={{ pathname: "/blog" }}
          className="text-lg tracking-tight text-black hover:text-gray-700"
        >
          Blog
        </Link>
        <a
          href="https://docs.openmind.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-lg tracking-tight text-black hover:text-gray-700"
        >
          Docs
        </a>
      </nav>

      {/* Desktop Buttons */}
      <div className="flex gap-4 max-lg:hidden">
        <a
          href="https://portal.openmind.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-5 py-2.5 text-lg text-center text-[#FD015F] border border-[#FD015F] rounded-[39px] hover:bg-rose-600 hover:text-white transition-colors"
        >
          Create OM Account
        </a>
        <a
          href="https://github.com/OpenmindAGI/OM1"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-5 py-2.5 text-lg text-center text-white bg-[#FD015F] border border-white rounded-[39px] hover:bg-[#DA0152] hover:text-white transition-colors"
        >
          Start Building
        </a>
      </div>

      {/* Mobile Menu Button */}
      <button
        className="hidden max-lg:block ml-auto text-black focus:outline-none"
        onClick={toggleMenu}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          {isOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>

      {/* Mobile Dropdown Menu */}
      <div
        className={`absolute top-full left-0 w-full bg-white shadow-md flex flex-col items-center py-4 gap-4 z-10 lg:hidden transform transition-transform duration-500 ease-in-out ${isOpen ? "translate-y-0 opacity-100 visible" : "-translate-y-10 opacity-0 invisible pointer-events-none"}`}
      >
        <Link
          to={{ pathname: "/about" }}
          className="text-lg tracking-tight text-black hover:text-gray-700"
          onClick={toggleMenu}
        >
          About
        </Link>
        <Link
          to={{ pathname: "/blog" }}
          className="text-lg tracking-tight text-black hover:text-gray-700"
          onClick={toggleMenu}
        >
          Blog
        </Link>
        <a
          href="https://docs.openmind.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-lg tracking-tight text-black hover:text-gray-700"
          onClick={toggleMenu}
        >
          Docs
        </a>
        <a
          href="https://portal.openmind.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-5 py-2.5 text-lg text-center text-[#FD015F] border border-[#FD015F] rounded-[39px] hover:bg-rose-600 hover:text-white transition-colors"
          onClick={toggleMenu}
        >
          Create OM Account
        </a>
        <a
          href="https://github.com/OpenmindAGI/OM1"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-5 py-2.5 text-lg text-center text-white bg-[#FD015F] border border-white rounded-[39px] hover:bg-[#DA0152] hover:text-white transition-colors"
          onClick={toggleMenu}
        >
          Start Building
        </a>
      </div>
    </header>
  );
};

export default Header;
